import React, { useEffect, useState } from 'react';
import MediumCard from './MediumCard';

const MEDIUM_FEED_URL = 'https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@astroKuhuk';

const Slider = () => {
  const [posts, setPosts] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    fetch(MEDIUM_FEED_URL)
      .then((res) => res.json())
      .then((data) => {
        const items = (data.items || []).filter((item) => item.categories.length > 0);
        setPosts(items);
        setStatus('loaded');
      })
      .catch(() => setStatus('error'));
  }, []);

  if (status === 'loading') {
    return <p className="text-body-center blog-status">loading posts...</p>;
  }

  if (status === 'error' || posts.length === 0) {
    return <p className="text-body-center blog-status">couldn't load posts right now — check back soon!</p>;
  }

  return (
    <div className="blog-grid">
      {posts.map((post) => (
        <MediumCard key={post.guid || post.link} {...post} />
      ))}
    </div>
  );
};

export default Slider;
